angular.module('ngWig')
    .config(['ngWigToolbarProvider', function (ngWigToolbarProvider) {
        ngWigToolbarProvider.addStandardButton('justifyCenter', 'justifyCenter', 'justifyCenter', 'fa-align-center');
        ngWigToolbarProvider.addStandardButton('justifyLeft', 'justifyLeft', 'justifyLeft', 'fa-align-left');
    }]);
